import { any, array, object, preprocess, TypeOf, union } from 'zod';

import { ChannelProduct } from './channel';
import { EpisodeProduct } from './episode';
import { GenericProduct } from './generic';
import { LiveEventProduct } from './live-event';

/* --------------------------------- Product -------------------------------- */

export const Product = union([
    ChannelProduct,
    EpisodeProduct,
    GenericProduct,
    LiveEventProduct,
]);
export type Product = TypeOf<typeof Product>;

/* --------------------------- AllProductsResponse -------------------------- */

export const AllProductsResponse = object({
    data: preprocess((data: unknown) => {
        const result = array(any()).parse(data);
        return result.filter(
            (x: unknown): x is Product => Product.safeParse(x).success,
        );
    }, array(Product)),
});
export type AllProductsResponse = TypeOf<typeof AllProductsResponse>;

/* --------------------------------- Exports -------------------------------- */

export * from './base';
export * from './channel';
export * from './episode';
export * from './extend';
export * from './feature';
export * from './generic';
export * from './live-event';
export * from './people';
export * from './trailer';
export * from './types';
